<template>
    <v-card>
        <v-card-title>Associer un Agent à un utilisateur</v-card-title>
        <v-card-text class="text-left">
            <v-select :items="agents" item-text="nom" item-value="id" label="Liste des Agents" v-model="agent_id"></v-select>
        </v-card-text>
        <v-card-actions class="py-5">
            <v-spacer></v-spacer>
            <v-btn
            color="primary darken-1"
            text
            @click="$emit('hide')"
            >
            Annuler
            </v-btn>
            <v-btn
            style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); margin-right:10px; color:white;"
            @click="associer"
            >
            Associer
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name: 'link-agent',
    data: () => ({
        agent_id: '',
        agents: []
    }),
    props:['user'],
    mounted(){
        this.axios.get("/users/unlinkedAgents")
            .then(res =>{
                this.agents = res.data
            })
    },
    methods: {
        associer(){
            this.axios.put("/user/associateAgent", {id: this.user.id, agent_id: this.agent_id}, {}).then(res => {
                console.log(res)
                this.$emit("reloadData", true)
                this.$emit("hide")
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/dashboard/users/actions/link.vue